import { useState } from "react";
import { useForm } from "react-hook-form";
import { ExerciseSetFromServer } from "../../libs/workout/types";
import { useCreateProgressionTemplateMutation } from "../../libs/progression/api";
import { ProgressionTemplateSet } from "../../libs/progression/types";
import { Modal } from "../Modal";
import { SubmitButton } from "../Button";

type WeeksData = {
  sets: ExerciseSetFromServer[] | undefined;
  notes?: string;
}[];

type Props = {
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
  exerciseName: string;
  weeks: WeeksData;
};

type FormValues = {
  name: string;
};

const toTemplateSet = (set: ExerciseSetFromServer): ProgressionTemplateSet => {
  const reps = typeof set.reps === "number" ? set.reps : 0;
  const repsRange = typeof set.repsRange === "number" ? set.repsRange : undefined;
  return { reps, repsRange, rest: set.rest };
};

export const SaveAsTemplateModal: React.FC<Props> = ({
  openModal,
  setOpenModal,
  exerciseName,
  weeks,
}) => {
  const [createTemplate, { isLoading, error, isSuccess }] =
    useCreateProgressionTemplateMutation();

  const { register, handleSubmit, reset } = useForm<FormValues>({
    defaultValues: { name: exerciseName },
  });

  const onSubmit = (data: FormValues) => {
    const validWeeks = weeks
      .map((w, i) => ({
        weekNumber: i + 1,
        sets: (w.sets || []).map(toTemplateSet),
        notes: w.notes || "",
      }))
      .filter((w) => w.sets.length > 0);

    createTemplate({
      name: data.name,
      numWeeks: weeks.length,
      weeks: validWeeks,
    })
      .unwrap()
      .then(() => {
        reset();
        setOpenModal(false);
      })
      .catch(() => {});
  };

  return (
    <Modal
      title="Salva come template progressione"
      openModal={openModal ? "save-as-template" : undefined}
      setOpenModal={() => setOpenModal(false)}
    >
      <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Nome template
          </label>
          <input
            {...register("name", { required: true })}
            type="text"
            className="block w-full py-2.5 px-4 text-sm text-gray-900 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <p className="text-xs text-gray-500">
          Verranno salvate le settimane che hanno almeno un set compilato (
          {weeks.filter((w) => w.sets && w.sets.length > 0).length} su{" "}
          {weeks.length}).
        </p>
        <SubmitButton isPending={isLoading}>Salva template</SubmitButton>
        {error && (
          <p className="text-sm text-red-600">
            Errore durante il salvataggio del template.
          </p>
        )}
      </form>
    </Modal>
  );
};
